export const ACTIONS = {
  SET_CHATBOX_POSITION: 'SET_CHATBOX_POSITION',
};

export const setChatBoxPosition = data => ({
  type: ACTIONS.SET_CHATBOX_POSITION,
  payload: data,
});
